/**
 * @module Components
 *
 */
import React, { FormEvent, ReactNode } from 'react';
import { LocaleString } from 'typedefs';
import { cls } from 'app/utils';
import { uuid } from 'app/utils/uuid';
import styles from './styles.module.scss';

export type PropsDef = {
  className?: string;
  name?: string;
  label?: LocaleString | ReactNode;
  disabled?: boolean;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  getRef?: (ref: any) => void;
  squareCheckIcons?: boolean;
  testId?: string;
};

export default function CheckBox(props: PropsDef) {
  const notifyParent = (e: FormEvent<HTMLInputElement>): void => {
    if (props.onChange) {
      props.onChange(e.currentTarget.checked);
    }
  };

  const handleRef = (ref: any) => {
    if (props.getRef) {
      props.getRef(ref);
    }
  };

  let iconTypes: { checked: string, unchecked: string };
  if (props.squareCheckIcons) {
    iconTypes = {
      checked: 'fa-check-square',
      unchecked: 'fa-square',
    };
   } else {
    iconTypes = {
      checked: 'fa-check-circle',
      unchecked: 'fa-circle',
    };
  }

  const id = uuid();
  const checked = props.checked ? true : false;
  return (
    <div className={cls(props.className, styles.index, props.disabled ? styles.disabled : '')} data-testid={props.testId}>
      <input
        id={id}
        name={props.name}
        type="checkbox"
        checked={checked}
        disabled={props.disabled}
        onChange={(e) => notifyParent(e)}
      />
      <label ref={handleRef} htmlFor={id}>
        <i className={`fas ${iconTypes.checked}`} aria-hidden="true"></i>
        <i className={`far ${iconTypes.unchecked}`} aria-hidden="true"></i>
        {props.label}
      </label>
      <div className={styles.clear}></div>
    </div>
  );
}

